<div class="details-view">

  <div class="details-view-head">
    <div class="details-view-row-top">
      <div class="back-btn">
        <a class="btn btn-circle" routerLink="/patient/{{patientTrialId}}"><i aria-hidden="true"
            class="icon-left"></i></a>
      </div>
      <div class="details-view-patient-details-wrap">

        <div class="patient-info-boxes" style="margin-bottom: 20px;">
          <div class="box-label">
            <label>Visit Name @if (visit.nonVisit) { <span class="non-visit-badge">Non-visit</span> }</label>
            <p>{{ visit.title }}</p>
          </div>

          <div class="box-label">
            <label>Visit Date</label>
            <p *ngIf="!visit.date">-</p>
            <p *ngIf="visit.date">
              <span class="field-value details-view-visit-date">{{ visit.date | date: 'd MMM yyyy' }}</span>
              <span class="field-value details-view-visit-time" style="margin-left: 20px;">{{ visit.timeMinutes !== null ?
                timeMinutesToStr(visit.timeMinutes) : '' }}</span>
            </p>
          </div>

          <div class="box-label">
            <label>{{ visit.typeDescription }}</label>
            <p *ngIf="visit.type != 'Home'">
              <span class="field-value details-view-visit-venue-name" *ngIf="visit.siteName">{{ visit.siteName }}</span>
              <span class="field-value details-view-visit-venue-address">{{ visit.siteAddress }}</span>
            </p>
          </div>
        </div>

        <div class="patient-info-boxes">
          <div class="box-label" *ngIf="visit.type === 'OnSite'">
            <label>{{visit.type}} Travel Requested?</label>
            <p>{{ stringHelper.addSpaces(visit.travelRequested) !== '' ? stringHelper.addSpaces(visit.travelRequested) : '-' }}</p>
          </div>

          <div class="box-label" *ngIf="visit.type === 'OnSite'">
            <label>Caregiver Travelling</label>
            <p>
                {{ stringHelper.addSpaces(visit.caregiverTravelling) != '' ? stringHelper.addSpaces(visit.caregiverTravelling) : '-' }}
            </p>
          </div>

          <div class="box-label">
            <label>Attendance</label>
            <p *ngIf="visit.attendance === 'PendingConfirmation'"><span class="badge badge-warning badge-outline">Pending Confirmation</span></p>
            <p *ngIf="visit.attendance === 'Cancelled'"><span class="badge badge-danger badge-outline">Cancelled</span></p>
            <p *ngIf="visit.attendance === 'NoShow'"><span class="badge badge-danger badge-outline">No Show</span></p>
            <p *ngIf="visit.attendance === 'Attended'"><span class="badge badge-success badge-outline">Attended</span></p>
            <p *ngIf="visit.attendance === 'AutoAttended'"><span class="badge badge-success badge-outline">Auto Attended</span></p>
          </div>

          <div class="box-label" *ngIf="getPreloadPaymentState()">
            <label>Preload State</label>
            <p *ngIf="getPreloadPaymentState() === 'Pending'"><span class="badge badge-warning badge-outline">Pending</span></p>
            <p *ngIf="getPreloadPaymentState() === 'Created'"><span class="badge badge-success badge-outline">Created</span></p>
          </div>
        </div>
      </div>
      <div class="visit-actions">
        <div class="visit-primary-actions">
          <a (click)="deleteVisitModal.show()"
             *ngIf="authService.hasPermission(Permissions.PatientVisitsWrite) && !visit.hasExpenses"
             class="btn btn-outline btn-width-auto">Delete</a>
          <a class="btn btn-secondary btn-width-auto" (click)="onHandleEditVisit()" *ngIf="authService.hasPermission(Permissions.PatientVisitsWrite)">Edit</a>
        </div>

      </div>
    </div>

    <div class="details-view-row-desc">
      @if (visit.description) {
        <div class="visit-description">
          <label>Description</label>
          <app-markdown-renderer [markdown]="visit.description"></app-markdown-renderer>
        </div>
      }

      @if (visit.notes) {
        <div class="visit-description">
          <label>Notes</label>
          <app-markdown-renderer [markdown]="visit.notes"></app-markdown-renderer>
        </div>
      }
    </div>
  </div>

  <div class="tabs-wrap">
    <div class="mobile-tabs">
      <select id="nav-tabs-select" class="selectpicker">
        <option value="#patient-visits-anchor">Visits</option>
        <option value="#patient-expenses-anchor">Expenses</option>
        <option value="#patient-additional-details-anchor">Additional Details</option>
        <option value="#patient-notes-anchor">Notes</option>
        <option value="#patient-activity-anchor">Activity</option>
        <option value="#patient-change-log-anchor" *ngIf="authService.hasPermission(Permissions.PatientChangeLogRead)">
          Change Log</option>
      </select>
    </div>

    <ul class="nav nav-tabs">
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientVisitsRead)">
        <a class="nav-link active" fragment="visits" routerLink="/patient/{{ patientTrialId }}">Visits</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientExpenseWrite) || authService.hasPermission(Permissions.PatientExpenseRead)">
        <a class="nav-link" fragment="expenses" routerLink="/patient/{{ patientTrialId }}">Expenses</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientDetailsRead)">
        <a class="nav-link" fragment="additional-details" routerLink="/patient/{{ patientTrialId }}">Additional
          Details</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientNotesRead)">
        <a class="nav-link" fragment="notes" routerLink="/patient/{{ patientTrialId }}">Notes</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientActivityRead)">
        <a class="nav-link" fragment="activity" routerLink="/patient/{{ patientTrialId }}">Activity</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientChangeLogRead)">
        <a class="nav-link" fragment="change-log"
           routerLink="/patient/{{ patientTrialId }}">Change Log</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoRead)">
        <a class="nav-link" fragment="payment-info" routerLink="/patient/{{ patientTrialId }}">Payment Info</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientDocumentsRead)">
        <a class="nav-link" fragment="documents" routerLink="/patient/{{ patientTrialId }}">Documents</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientEdiaryRead) && patient.diaryEnabled">
        <a class="nav-link" fragment="diary" routerLink="/patient/{{ patientTrialId }}">Maze E-Diary</a>
      </li>
      <li class="nav-item" *ngIf="authService.hasPermission(Permissions.PatientEdiaryRead) && patient.genericDiaryEnabled">
        <a class="nav-link" fragment="generic-diary" routerLink="/patient/{{ patientTrialId }}">E-Diary</a>
      </li>
    </ul>
  </div>

  <div class="tab-content" id="details-view-tab-content">

    <div class="content-panel patient-trip-details">

      <div id="red-bar-container" style="min-height: 112px;">
        <div class="patient-trip-red-bar" #redDetailsBar>
          <table aria-hidden="true">
            <tr>
              <td>
                <span class="label">Patient Name</span>
                <span class="text">{{ stringHelper.limit(patient.getFullName(), 30) }}</span>
              </td>
              <td>
                <span class="label">Patient ID</span>
                <span class="text">{{ patient.shortId }} <a
                    (click)="onCopiedToClipboard('Patient ID copied to your clipboard')"
                    [cdkCopyToClipboard]="patient.shortId" title="Copy Patient ID to clipboard"><img alt="Copy"
                      src="/assets/img/icon-copy.svg"></a></span>
              </td>
              <td>
                <span class="label">Visit ID</span>
                <span class="text">{{ visit.shortId }} <a
                    (click)="onCopiedToClipboard('Visit ID copied to your clipboard')"
                    title="Copy Visit ID to clipboard" [cdkCopyToClipboard]="visit.shortId"><img
                      src="/assets/img/icon-copy.svg" alt="Copy"></a></span>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- Call Information Panel -->
      <div class="call-info-panel" *ngIf="showCallInfo">
        <!-- Header with consent -->
        <div class="call-info-panel__header">
          <div class="call-info-panel__title-area">
            <div class="call-info-panel__icon-container">
              <i class="fas" [ngClass]="visit.virtualCallType === 'Audio' ? 'fa-phone' : 'fa-video'"></i>
            </div>
            <span class="call-info-panel__title">{{ callTypeLabel }}</span>
          </div>
          <div class="call-info-panel__consent">
            <div class="call-info-panel__consent-text call-info-panel__consent-text--right">
              <span class="call-info-panel__consent-title">{{ consentStatus }}</span>
              <span *ngIf="showConsentTimestamp" class="call-info-panel__consent-subtitle">
                {{ visit.patientRecordingConsentDateUtc | date:'d MMM yyyy, h:mm a' }}
              </span>
              <span *ngIf="visit.recordingAskForConsent && !visit.patientRecordingConsentDateUtc" class="call-info-panel__consent-subtitle">
                Patient has not been asked for recording consent
              </span>
            </div>
            <div class="call-info-panel__consent-icon" [ngClass]="consentIconClass">
              <i class="fas" [ngClass]="{
                'fa-check': !visit.recordingAskForConsent || visit.patientRecordingConsent,
                'fa-times': visit.recordingAskForConsent && !visit.patientRecordingConsent && visit.patientRecordingConsentDateUtc,
                'fa-question': visit.recordingAskForConsent && !visit.patientRecordingConsentDateUtc
              }"></i>
            </div>
          </div>
        </div>

        <div class="call-info-panel__divider"></div>

        <!-- Resources -->
        <div class="call-info-panel__section">
          <span class="call-info-panel__label">Resources</span>
          <div *ngIf="callResources.length > 0">
            <table class="table table-sm call-info-panel__table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let resource of callResources">
                  <td>{{ resource.type }}</td>
                  <td>{{ resource.name }}</td>
                  <td>
                    <span class="badge"
                      [ngClass]="{'badge-warning': resource.status === 'Pending', 'badge-success': resource.status === 'Ready', 'badge-danger': resource.status === 'Failed'}">
                      {{ resource.status }}
                    </span>
                  </td>
                  <td>{{ resource.createdDisplay }}</td>
                  <td class="call-info-panel__actions">
                    <app-button *ngIf="resource.type !== 'Transcript'"
                      text="Play" faIcon="fas fa-play" variant="secondary" size="sm"
                      [disabled]="resource.status !== 'Ready' || loadingRecordingId !== null"
                      (clicked)="onPlayResource(resource)">
                    </app-button>
                    <app-button *ngIf="resource.type === 'Transcript'"
                      text="Download" faIcon="fas fa-download" variant="secondary" size="sm"
                      [disabled]="resource.status !== 'Ready'"
                      (clicked)="onDownloadTranscript(resource)">
                    </app-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="callResources.length === 0" class="call-info-panel__empty">
            <i class="fas fa-microphone call-info-panel__empty-icon"></i>
            <div class="call-info-panel__empty-title">No recordings</div>
            <div class="call-info-panel__empty-description">There are no call recordings available yet</div>
          </div>
        </div>
      </div>

      <!-- Audio Playback Modal -->
      <app-modal #playbackModal>
        <div class="modal-header">
          <h5 class="modal-title">{{ playbackTitle }}</h5>
        </div>
        <div class="modal-body">
          <audio *ngIf="playbackUrl" [src]="playbackUrl" controls autoplay class="call-info-panel__player"></audio>
          <div *ngIf="!playbackUrl" class="call-info-panel__loader">
            <i class="fas fa-circle-notch fa-spin"></i>
            <span>Loading recording…</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="onClosePlayback()">Close</button>
        </div>
      </app-modal>

      <!-- Video Playback Modal -->
      <app-video-player-modal #videoPlaybackModal (closed)="onClosePlayback()"></app-video-player-modal>

      <div class="patient-trip-head" *ngIf="!showCallInfo">
        <a class="btn btn-outline btn-slim btn-auto-width" (click)="addEditTripModal.showAddTripModal(visit.id)" *ngIf="authService.hasPermission(Permissions.PatientVisitsWrite)">+ Add Trip</a>
        <a class="btn btn-secondary btn-slim btn-auto-width" style="margin-right: 20px;" (click)="onCreatePrePaymentExpenseClaim()" *ngIf="!visit.preloadExpenseCreated && visit.preloadPaymentDate && (environmentName === 'DEVELOPMENT' || environmentName === 'STAGING')">
          <span *ngIf="!creatingPrePaymentExpenseClaim">Create PrePayment Expense</span>
          <span class="spinner" *ngIf="creatingPrePaymentExpenseClaim">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </span>
        </a>

        <span class="badge badge-success" *ngIf="visit.trips.length > 0">Accepted</span>
      </div>

      <div cdkDropList *ngIf="!showCallInfo">
        <div class="patient-visit-trip" *ngFor="let trip of visit.trips; let i = index;" cdkDrag [cdkDragDisabled]="!authService.hasPermission(Permissions.PatientVisitsWrite)"
          (cdkDragDropped)="onDrop($event)" (cdkDragStarted)="onDrag(i)">
          <div class="patient-visit-trip-actions desktop">
            <a (click)="onDeleteTrip(trip)" class="btn btn-outline btn-slim btn-auto-width"
              *ngIf="authService.hasPermission(Permissions.PatientDelete) && (trip.rideHealthStatus === 'NotApplicable' || trip.rideHealthStatus === '')">Delete</a>
            <a class="btn btn-secondary btn-slim btn-auto-width" (click)="addEditTripModal.showEditTripModal(trip.id)" *ngIf="authService.hasPermission(Permissions.PatientVisitsWrite)">Edit</a>
            <a class="btn btn-secondary btn-slim btn-auto-width" (click)="addEditTripModal.showEditTripModal(trip.id)" *ngIf="authService.hasPermission(Permissions.PatientVisitsRead) && !authService.hasPermission(Permissions.PatientVisitsWrite)">View</a>
          </div>

          <h3 cdkDragHandle *ngIf="authService.hasPermission(Permissions.PatientVisitsWrite)">
            <i class="icon-elipsis" aria-hidden="true"></i> <span class="round-trip" *ngIf="trip.direction === PatientTripDirection.RoundTrip">R</span> {{ trip.type }} <span class="trip-status-badge badge badge-status-{{ trip.bookingStatus.toLowerCase() }}">{{ getTripBookingStatusDescription(trip.bookingStatus) }}</span>
          </h3>

          <h3 *ngIf="!authService.hasPermission(Permissions.PatientVisitsWrite)">
            <span class="round-trip" *ngIf="trip.direction === PatientTripDirection.RoundTrip">R</span> {{ trip.type }} <span class="trip-status-badge badge badge-status-{{ trip.bookingStatus.toLowerCase() }}">{{ getTripBookingStatusDescription(trip.bookingStatus) }}</span>
          </h3>

          <div class="inner">
            <table aria-hidden="true">
              <tr role="row">
                <td class="departure-date-time-cell" role="columnheader">
                  <span class="label">{{ getDepartureLabel(trip.type) }}</span>
                  <span class="date-time">
                    <span class="field-value date">{{ trip.departureDate | date: 'd MMM yyyy' }}</span>
                    <span class="field-value time" *ngIf="trip.departureTimeMinutes !== null">{{ trip.departureDate | date: 'h:mm aaa' }}</span>
                  </span>
                </td>
                <td class="departure-location-cell" role="columnheader">
                  <span *ngIf="trip.type !== 'Accommodation'">
                    <span class="label">From</span>
                    <span class="field-value location-from">{{ stringHelper.limit(trip.departureLocation, 30) }}</span>
                  </span>
                </td>
                <td class="arrival-date-time-cell" role="columnheader">
                  <div *ngIf="trip.arrivalDate !== null">
                    <span class="label">{{ getArrivalLabel(trip.type) }}</span>
                    <span class="date-time">
                      <span class="field-value date">{{ trip.arrivalDate | date: 'd MMM yyyy' }}</span>
                      <span class="field-value time" *ngIf="trip.arrivalTimeMinutes !== null">{{ trip.arrivalDate | date: 'h:mm aaa' }}</span>
                    </span>
                  </div>
                </td>
                <td class="arrival-location-cell" role="columnheader">
                  <span *ngIf="trip.type !== 'Accommodation'">
                    <span class="label">To</span>
                    <span class="location-from">{{ stringHelper.limit(trip.arrivalLocation, 30) }}</span>
                  </span>
                </td>
              </tr>
            </table>

            <table *ngIf="trip.rideHealthStatus !== 'NotApplicable'" aria-hidden="true" class="trip-state-table">
              <tr>
                <td class="departure-date-time-cell">
                  <span class="label">Trip State</span>
                  <span class="date-time">
                    <span class="field-value date">{{ trip.rideHealthState }}</span>
                  </span>
                </td>
                <td class="departure-location-cell">
                  <span *ngIf="trip.type !== 'Accommodation'">
                    <span class="label">Latest Status Received</span>
                    <span class="field-value location-from">{{ trip.rideHealthStatus }}</span>
                  </span>
                </td>
                <td class="arrival-date-time-cell">
                  <div *ngIf="trip.arrivalDate !== null">
                    <span class="label">Latest Status Date &amp; Time</span>
                    <span class="date-time">
                      <span class="field-value date">{{ trip.rideHealtStatusUpdatedAt | date: 'd MMM yyyy' }}</span>
                      <span class="field-value time">{{ trip.rideHealtStatusUpdatedAt | date: 'h:mm aaa' }}</span>
                    </span>
                  </div>
                </td>
                <td class="arrival-location-cell">
                </td>
              </tr>
            </table>

            <table *ngIf="trip.type == 'Accommodation'" aria-hidden="true" class="location-details-table">
              <tr>
                <td class="accommodation-location-cell">
                  <span class="label">Location</span>
                  <span class="field-value location-from">{{ trip.accommodationLocation }}</span>
                </td>
                <td class="accommodation-details-cell">
                  <span class="label">Details</span>
                  <span class="location-from">{{ trip.notes }}</span>
                </td>
              </tr>
            </table>

            <div class="pdf-generating" *ngIf="trip.pdfGenerating">
              <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
              <span class="generating-text">Generating PDF, please wait...</span>
            </div>

            <ul class="attachments" *ngIf="!trip.pdfGenerating">
              <li *ngIf="trip.ticketId"><i class="icon-paperclip" aria-hidden="true"></i> <a href="{{ trip.ticketUrl }}"
                  target="_blank" rel="noopener">{{ trip.ticketOriginalFilename }}</a>
              </li>
            </ul>

            <p class="added-by-user">Added by <strong>{{ trip.addedBy }}</strong> on
              <strong>{{ trip.addedByDate | date: 'd MMM yyyy' }}</strong> at
              <strong>{{ trip.addedByDate | date: 'h:mm aaa' }}</strong>
            </p>

            <div class="patient-visit-trip-actions mobile">
              <a class="btn btn-secondary btn-slim btn-auto-width" (click)="addEditTripModal.showEditTripModal(trip.id)" *ngIf="authService.hasPermission(Permissions.PatientVisitsWrite)">Edit</a>
              <a (click)="onDeleteTrip(trip)" class="btn btn-outline btn-slim btn-auto-width"
                *ngIf="authService.hasPermission(Permissions.PatientDelete)">Delete</a>
            </div>
          </div>

        </div>
      </div>

      <div class="no-results inside" *ngIf="!showCallInfo && visit.trips.length == 0">
        <div class="inner">
          <div class="content">
            <h2>No Trips</h2>
            <p>There are no trips for this patient.</p>
          </div>
        </div>
      </div>

    </div>

  </div>

</div>

<!-- Start: Delete visit modal -->
<app-modal #deleteVisitModal>
  <div class="modal-header">
    <h2 class="modal-title">Delete Visit?</h2>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this visit?</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="deleteVisitModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
      </div>

      <div class="col-6">
        <a (click)="onDeleteVisitConfirmed()" class="btn btn-primary">
          <span *ngIf="isDeleteVisitProcessing">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </span>
          <span *ngIf="!isDeleteVisitProcessing">Delete</span>
        </a>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Delete visit modal -->

<!-- Start: Delete trip modal -->
<app-modal #deleteTripModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Delete Trip?</h2>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete this this?</p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="deleteTripModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>

        <div class="col-6">
          <a (click)="onConfirmDeleteTrip()" class="btn btn-primary" [ngClass]="{'disabled': isDeleteProcessing}">
            <span *ngIf="isDeleteProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <span *ngIf="!isDeleteProcessing">Delete</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Delete trip modal -->

<app-edit-visit-modal #editVisitModal (addedOrUpdated)="loadVisit()"></app-edit-visit-modal>

<app-add-edit-trip-modal #addEditTripModal (tripUpdated)="loadVisit()" (tripAdded)="onHandleTripAdded($event)" [muvEnabled]="visit.muvEnabled"></app-add-edit-trip-modal>


